import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '../layouts/AppLayout'
Vue.use(Router)
const sysRole = () => import('../views/generator/sysRole')
const sysUserInfo = () => import('../views/generator/sysUserInfo')
// const registerManager = () => import('../views/generator/registerManager')
const record = () => import('../views/generator/record')
const recordTotal = () => import('../views/generator/recordTotal')
const ftHis = () => import('../views/generator/ftHis')
const ft = () => import('../views/generator/ft')
const ftTwo = () => import('../views/generator/ftTwo')
const ftTwoHis = () => import('../views/generator/ftTwoHis')
const ftThree = () => import('../views/generator/ftThree')
const ftThreeHis = () => import('../views/generator/ftThreeHis')
const ftFour = () => import('../views/generator/ftFour')
const ftFourHis = () => import('../views/generator/ftFourHis')
const ftFive = () => import('../views/generator/ftFive')
const ftFiveHis = () => import('../views/generator/ftFiveHis')
const bt = () => import('../views/generator/bt')
const btHis = () => import('../views/generator/btHis')
const btTwo = () => import('../views/generator/btTwo')
const btTwoHis = () => import('../views/generator/btTwoHis')
const btThree = () => import('../views/generator/btThree')
const btThreeHis = () => import('../views/generator/btThreeHis')
const btFour = () => import('../views/generator/btFour')
const btFourHis = () => import('../views/generator/btFourHis')
const btFive = () => import('../views/generator/btFive')
const btFiveHis = () => import('../views/generator/btFiveHis')
const Login = () => import('../pages/login')
const appLogin = () => import('../pages/appLogin')
const appMain = () => import('../views/app/appMain')
const appOrder = () => import('../views/app/appOrder')
const appOrderManage = () => import('../views/app/appOrderManage')
const appSysUserInfo = () => import('../views/app/appSysUserInfo')
/* const doc = () => import('../views/generator/doc') */
const router = new Router({
  mode: 'history',
  routes: [
    {
      name: '',
      path: '/',
      component: Login
    },
    {
      name: 'login',
      path: '/login',
      component: Login
    },
    {
      name: 'appLogin',
      path: '/appLogin',
      component: appLogin
    },
    {
      name: 'layout',
      path: '',
      component: AppLayout,
      children: [
        {
          name: 'ft',
          path: '/ft',
          meta: {
            title: '足彩胜平负'
          },
          component: ft
        },
        {
          name: 'ftHis',
          path: '/ftHis',
          meta: {
            title: '足彩胜平负'
          },
          component: ftHis
        },
        {
          name: 'ftTwo',
          path: '/ftTwo',
          meta: {
            title: '足彩比分'
          },
          component: ftTwo
        },
        {
          name: 'ftTwoHis',
          path: '/ftTwoHis',
          meta: {
            title: '足彩比分'
          },
          component: ftTwoHis
        },
        {
          name: 'ftThree',
          path: '/ftThree',
          meta: {
            title: '足彩总进球数'
          },
          component: ftThree
        },
        {
          name: 'ftThreeHis',
          path: '/ftThreeHis',
          meta: {
            title: '足彩总进球数'
          },
          component: ftThreeHis
        },
        {
          name: 'ftFour',
          path: '/ftFour',
          meta: {
            title: '足彩半全场胜平负'
          },
          component: ftFour
        },
        {
          name: 'ftFourHis',
          path: '/ftFourHis',
          meta: {
            title: '足彩半全场胜平负'
          },
          component: ftFourHis
        },
        {
          name: 'ftFive',
          path: '/ftFive',
          meta: {
            title: '足彩混合过关'
          },
          component: ftFive
        },
        {
          name: 'ftFiveHis',
          path: '/ftFiveHis',
          meta: {
            title: '足彩混合过关'
          },
          component: ftFiveHis
        },
        {
          name: 'bt',
          path: '/bt',
          meta: {
            title: '篮彩胜负'
          },
          component: bt
        },
        {
          name: 'btHis',
          path: '/btHis',
          meta: {
            title: '篮彩胜负'
          },
          component: btHis
        },
        {
          name: 'btTwo',
          path: '/btTwo',
          meta: {
            title: '篮彩让分胜负'
          },
          component: btTwo
        },
        {
          name: 'btTwoHis',
          path: '/btTwoHis',
          meta: {
            title: '篮彩让分胜负'
          },
          component: btTwoHis
        },
        {
          name: 'btThree',
          path: '/btThree',
          meta: {
            title: '篮彩胜分差'
          },
          component: btThree
        },
        {
          name: 'btThreeHis',
          path: '/btThreeHis',
          meta: {
            title: '篮彩胜分差'
          },
          component: btThreeHis
        },
        {
          name: 'btFour',
          path: '/btFour',
          meta: {
            title: '篮彩大小分'
          },
          component: btFour
        },
        {
          name: 'btFourHis',
          path: '/btFourHis',
          meta: {
            title: '篮彩大小分'
          },
          component: btFourHis
        },
        {
          name: 'btFive',
          path: '/btFive',
          meta: {
            title: '篮彩混合过关'
          },
          component: btFive
        },
        {
          name: 'btFiveHis',
          path: '/btFiveHis',
          meta: {
            title: '篮彩混合过关'
          },
          component: btFiveHis
        },
        {
          name: 'record',
          path: '/record',
          meta: {
            title: '订单管理'
          },
          component: record
        },
        {
          name: 'appOrderManage',
          path: '/appOrderManage',
          meta: {
            title: 'APP订单管理'
          },
          component: appOrderManage
        },
        {
          name: 'recordTotal',
          path: '/recordTotal',
          meta: {
            title: '订单统计'
          },
          component: recordTotal
        },
        /* {
          name: 'registerManager',
          path: '/registerManager',
          meta: {
            title: '用户管理'
          },
          component: registerManager
        }, */
        {
          name: 'sysRole',
          path: '/sysRole',
          component: sysRole,
          meta: {
            title: '角色管理'
          }
        },
        {
          name: 'sysUserInfo',
          path: '/sysUserInfo',
          component: sysUserInfo,
          meta: {
            title: '用户管理'
          }
        },
        {
          name: 'appSysUserInfo',
          path: '/appSysUserInfo',
          component: appSysUserInfo,
          meta: {
            title: 'APP用户管理'
          }
        }
      ]
    },
    // 手机版
    {
      name: 'appOrder', // 手机注册 // 非易术佳公众号注册的
      path: '/appOrder',
      component: appOrder
    },
    {
      name: 'appOrder', // 手机注册 // 非易术佳公众号注册的
      path: '/appOrder',
      component: appOrder
    },
    {
      name: 'appOrderManage', // 手机注册 // 非易术佳公众号注册的
      path: '/appOrderManage',
      component: appOrderManage
    },
    {
      name: 'appMain', // 手机注册 // 非易术佳公众号注册的
      path: '/appMain',
      component: appMain
    }
  ]
})
// 路由全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/') {
    next()
  } else {
    let registerToken = localStorage.getItem('token')
    if (registerToken == null || registerToken === '') {
      /* if (to.path.includes('app')) {
        return next('/appLogin')
      } */
      return next('/login')
    } else {
      if (to.path === '' || to.path === '/') {
        return next('/login')
      }
      return next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js